import { Testimonials } from './testimonials';
import { VStack, Heading, Text, Box } from '@chakra-ui/react';
import { RoundedCorner, LayoutContainer } from '@components';

export function Community(): JSX.Element {
  return (
    <LayoutContainer noHorizontalPadding pos="relative">
      <VStack spacing={4} mb={12} px={{ base: 6, lg: 8 }}>
        <Heading textAlign="center">
          An{' '}
          <Box as="span" color="primary.500">
            ever-growing{' '}
          </Box>
          community
        </Heading>

        <Text textAlign="center">
          From industry leaders to hobbyists, everyone is talking about it.
        </Text>
      </VStack>
      <Testimonials />
      <Box display={{ base: 'none', lg: 'inline-flex' }}>
        <RoundedCorner
          canvasHeight={160}
          bg={'#F8F9FC'}
          yPosition="bottom"
          xPosition="left"
        />
        <RoundedCorner
          canvasHeight={160}
          bg={'#F8F9FC'}
          yPosition="bottom"
          xPosition="right"
        />
      </Box>
    </LayoutContainer>
  );
}
